import { keysToCamelCase } from "@jti/fe-common";
export const getSticksMatrixResponseMock = () => ({
    getSticksMatrix: {
        single_packs: {
            onetime: [
                {
                    flavour: 14,
                    flavour_label: "Bronze",
                    sku: "sticks-pack-bronze",
                    swatch_data: "#fffcde",
                },
                {
                    flavour: 13,
                    flavour_label: "Gold",
                    sku: "sticks-pack-gold",
                    swatch_data: "#cfc613",
                },
                {
                    flavour: 15,
                    flavour_label: "Silver",
                    sku: "sticks-pack-silver",
                    swatch_data: "#acacac",
                },
                {
                    flavour: 16,
                    flavour_label: "Amber",
                    sku: "sticks-pack-amber",
                    swatch_data: "#b3022e",
                },
                {
                    flavour: 37,
                    flavour_label: "Tan",
                    sku: "sticks-pack-tan",
                    swatch_data: "#e0d561",
                },
                {
                    flavour: 40,
                    flavour_label: "Burgundy",
                    sku: "sticks-pack-burgundy",
                    swatch_data: "#9e091b",
                },
            ],
            subscription: [],
        },
        cartons: {
            onetime: [
                {
                    flavour: 14,
                    flavour_label: "Bronze",
                    sku: "sticks-carton-bronze",
                    swatch_data: "#fffcde",
                },
                {
                    flavour: 13,
                    flavour_label: "Gold",
                    sku: "sticks-carton-gold",
                    swatch_data: "#cfc613",
                },
                {
                    flavour: 15,
                    flavour_label: "Silver",
                    sku: "sticks-carton-silver",
                    swatch_data: "#acacac",
                },
                {
                    flavour: 16,
                    flavour_label: "Amber",
                    sku: "sticks-carton-amber",
                    swatch_data: "#b3022e",
                },
                {
                    flavour: 37,
                    flavour_label: "Tan",
                    sku: "sticks-carton-tan",
                    swatch_data: "#e0d561",
                },
                {
                    flavour: 40,
                    flavour_label: "Burgundy",
                    sku: "sticks-carton-burgundy",
                    swatch_data: "#9e091b",
                },
            ],
            subscription: [
                {
                    flavour: 14,
                    flavour_label: "Bronze",
                    sku: "sticks-carton-bronze-subscription",
                    swatch_data: "#fffcde",
                },
                {
                    flavour: 13,
                    flavour_label: "Gold",
                    sku: "sticks-carton-gold-subscription",
                    swatch_data: "#cfc613",
                },
                {
                    flavour: 15,
                    flavour_label: "Silver",
                    sku: "sticks-carton-silver-subscription",
                    swatch_data: "#acacac",
                },
                {
                    flavour: 37,
                    flavour_label: "Tan",
                    sku: "sticks-carton-tan-subscription",
                    swatch_data: "#e0d561",
                },
                {
                    flavour: 40,
                    flavour_label: "Burgundy",
                    sku: "sticks-carton-burgundy-subscription",
                    swatch_data: "#9e091b",
                },
            ],
        },
        mix_n_match: {
            onetime: [
                {
                    sku: "sticks-mix-n-match",
                },
            ],
            subscription: [
                {
                    sku: "sticks-mix-n-match-subscription",
                },
            ],
        },
    },
});
export const getSticksMatrixFormattedResponseMock = () => keysToCamelCase(getSticksMatrixResponseMock().getSticksMatrix);
//# sourceMappingURL=getSticksMatrixResponse.mock.js.map